export const SHOW_MODAL = 'showModal';
export const GO_BACK_VIEW = 'goBackView';
export const REBUILD_PATH = 'rebuildPath';
export const SHOW_OVERLAY = 'showOverlay';
export const NOTIFY_ERROR = 'notifyError';
export const GUIDE_JUMP_TO = 'guideJumpTo';
export const DROP_OVERLAY = 'dropOverlay';
export const SUCCESS_SEARCH = 'successSearch';
export const RESTORE_LOCALE = 'restoreLocale';
export const PATH_REBUILDED = 'pathRebuilded';
export const GUIDE_NEW_POINT = 'guideNewPoint';
export const UNSUCCESS_SEARCH = 'unsuccessSearch';
export const SESSION_EXTENDED = 'sessionExtended';
export const LOADING_PROGRESS = 'loadingProgress';
export const NO_DIRECT_MATCHES = 'noDirectMatches';
export const SEARCH_DATA_CHANGE = 'searchDataChange';
export const CHECK_SEARCH_VALUE = 'checkSearchValue';
export const SESSION_TERMINATED = 'sessionTerminated';
export const ERASE_SEARCH_STRING = 'eraseSearchString';
export const START_GUIDE_OVERVIEW = 'startGuideOverview';
export const GUIDE_CLOSE_SEARCHBAR = 'guideCloseSearchbar';
export const TERMINAL_ID_CHANGED = 'terminalIdChanged';
export const SHOW_WARNING_MODAL = 'showWarningModal';

export const OBJECT_INFO_CLOSE_CLICK = 'object_info_close_click';

const EVENTS = {
    MODALS: {
        INIT_TILES_MODAL: 'initTilesModal',
        INIT_SMS_MODAL_STANDARD: 'initSmsModalStandard',
        INIT_SERVICES_MODAL: 'initServicesModal',
        OFF_MODAL: 'offModal',
        INIT_INFO_MODAL: 'initInfoModal',
        OFF_INFO_MODAL: 'offInfoModal',
        INIT_SMS_MODAL_OTG: 'initSmsModalOtg',
        PROCEED_TO_REQUEST_PERMISSIONS: 'proceedToRequestPermissions',
        OPENING_HOURS_INIT: 'openingHoursInit',
        MOBILE_MAP_INIT: 'mobileMapInit',
        OPENING_ABOUT_MODAL: 'openingAboutModal'
    },
    DISABLE_AR_VIEW: 'disableArView',
    KEYBOARD_STANDARD: {
        REMOVE_VALUE: 'keyboardStandardRemoveValue',
        INIT_KEYBOARD: 'keyboardStandardInitKeyboard',
        CLOSE_KEYBOARD: 'keyboardStandardCloseKeyboard',
        CHANGE_SEARCH_QUERY: 'keyboardStandardChangeSearchQuery'
    }
};

export {
    EVENTS
}
